import { useEffect, useState } from 'react';
import useWindowDimensions from './useWindowDimensions';

const useIsMobile = (): boolean => {
	const [isMobile, setIsMobile] = useState(false);
	const { width, height } = useWindowDimensions();

	useEffect(() => {
		setIsMobile(width <= 768 && height <= 1024);
	}, [width, height]);

	return isMobile;
};

export default useIsMobile;
